<div class="modal-header" id="confirmation-material-goods-info-modal-title">
    <h3 class="modal-title">{{ header }}</h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <div class="row">
        <label class="col-4 col-form-label" translate="CONFIRMATION_MATERIAL_DANGEROUS_GOODS_PROF_LABEL"></label>
        <div class="col-8 form-control-plaintext">{{ profText }}</div>
    </div>
    <div class="row">
        <label class="col-4 col-form-label" translate="CONFIRMATION_MATERIAL_DANGEROUS_GOODS_STOF_LABEL"></label>
        <div class="col-8 form-control-plaintext">{{ stofText }}</div>
    </div>
    <p>{{ dgpText }}</p>
</div>
